import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, type Observable } from 'rxjs';

import { HttpClientService } from '../../../../../core/services/http-client.service';
import type { VarianceIncidentDetailsClient } from '../../../../../core/tokens/variance-incident-details-client.token';
import { INCIDENTS } from '../../../../../shared/constants/api-routes.constants';
import type { VarianceIncident } from '../models/variance-incident.model';
import { mapIncidentApiPayloadToVarianceIncident } from '../utils/variance-incident-api.mapper';

@Injectable({ providedIn: 'root' })
export class VarianceIncidentDetailsService implements VarianceIncidentDetailsClient {
  private readonly http = inject(HttpClientService);

  getIncidentDetails(incidentNumber: string, organizationId: string): Observable<VarianceIncident> {
    const params = new HttpParams().set('organizationId', organizationId);
    return this.http
      .get<unknown>(INCIDENTS.BY_ID(incidentNumber), { params })
      .pipe(map(mapIncidentApiPayloadToVarianceIncident));
  }
}
